import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createComponent = (type, data) => ({
  type: ActionTypes.COMPONENT_CREATE,
  payload: {
    type,
    data,
  },
});

export const updateComponent = (type, id, data) => ({
  type: ActionTypes.COMPONENT_UPDATE,
  payload: {
    type,
    id,
    data,
  },
});

export const deleteComponent = (id) => ({
  type: ActionTypes.COMPONENT_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createComponentRequested = (type, data) => ({
  type: ActionTypes.COMPONENT_CREATE_REQUESTED,
  payload: {
    type,
    data,
  },
});

export const createComponentSuccessed = (data) => ({
  type: ActionTypes.COMPONENT_CREATE_SUCCESSDED,
  payload: {
    data,
  },
});

export const createComponentFailed = (error) => ({
  type: ActionTypes.COMPONENT_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createComponentReceived = (data) => ({
  type: ActionTypes.COMPONENT_CREATE_RECEIVED,
  payload: {
    data,
  },
});

export const updateComponentRequested = (type, id, data) => ({
  type: ActionTypes.COMPONENT_UPDATE_REQUESTED,
  payload: {
    type,
    id,
    data,
  },
});

export const updateComponentSuccessed = (data) => ({
  type: ActionTypes.COMPONENT_UPDATE_SUCCESSDED,
  payload: {
    data,
  },
});

export const updateComponentFailed = (id, error) => ({
  type: ActionTypes.COMPONENT_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateComponentReceived = (data) => ({
  type: ActionTypes.COMPONENT_UPDATE_RECEIVED,
  payload: {
    data,
  },
});

export const deleteComponentRequested = (id) => ({
  type: ActionTypes.COMPONENT_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteComponentSuccessed = (data) => ({
  type: ActionTypes.COMPONENT_DELETE_SUCCESSDED,
  payload: {
    id: data.id,
  },
});

export const deleteComponentFailed = (id, error) => ({
  type: ActionTypes.COMPONENT_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteComponentReceived = (id) => ({
  type: ActionTypes.COMPONENT_DELETE_RECEIVED,
  payload: {
    id,
  },
});
